// ScalaVisione tasarım sistemi — panel sürümü.
//
// Kaynak: ScalaVisioneTRV2/frontend/app/globals.css
// Renkler, gradyanlar, yüzey tarifleri ve geçiş eğrileri ana siteden BİREBİR
// alındı. Panel bağlamında tek fark ölçek: gövde 0.9375rem, kart yarıçapı 16px
// (sitede 20px) ve film greni yok — bir kontrol panelinde sürekli hareket eden
// doku yorucu oluyor. Renk ve gramer aynen korunuyor.

export const BRAND = {
  // Zeminler
  void: "#05070c",
  base: "#080b12",
  surface: "#0e1320",
  surface2: "#151d2e",
  surface3: "#1d2740",

  // Metin
  ink: "#eaf0f8",
  inkDim: "#97a5bd",
  inkFaint: "#74829c",

  // Marka aksanları (logo gradyanı)
  ember: "#ff6b2c",
  flare: "#ffa14d",
  cyan: "#2da7ff",
  azure: "#1d6ff2",
  deep: "#1547b8",

  // Durum
  mint: "#3ddc97",
  rose: "#ff6b81",
};

// Vurgu gradyanı bilinçli olarak tek renk ailesinde kalır (açık cyan → derin
// azure). Üç renkli geçiş tek kelimede gökkuşağı etkisi yapıyordu.
export const GRADIENT = {
  brand: `linear-gradient(135deg, ${BRAND.cyan} 0%, ${BRAND.azure} 100%)`,
  text: `linear-gradient(100deg, #9adcff 0%, ${BRAND.cyan} 42%, ${BRAND.azure} 100%)`,
  rule: `linear-gradient(90deg, transparent, rgba(234,240,248,0.12), transparent)`,
  kickerRule: `linear-gradient(90deg, ${BRAND.cyan}, transparent)`,
};

export const LINE = {
  hairline: "rgba(234, 240, 248, 0.09)",
  hairlineStrong: "rgba(234, 240, 248, 0.18)",
};

export const EASE = {
  outExpo: "cubic-bezier(0.16, 1, 0.3, 1)",
  inOutQuint: "cubic-bezier(0.83, 0, 0.17, 1)",
};

export const FONT = {
  sans: '"Geist", ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif',
  mono: '"Geist Mono", ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace',
};

// Sitedeki `glass` utility'sinin birebir karşılığı.
export const GLASS = {
  background: `linear-gradient(150deg, rgba(14,19,32,0.82), rgba(8,11,18,0.78))`,
  backdropFilter: "blur(18px) saturate(130%)",
  WebkitBackdropFilter: "blur(18px) saturate(130%)",
  border: `1px solid ${LINE.hairline}`,
};

export const SHADOW = {
  card: "0 8px 32px 0 rgba(0, 0, 0, 0.45)",
  raised: "0 24px 60px -24px rgba(0, 0, 0, 0.85)",
  cyan: `0 10px 40px -12px rgba(45, 167, 255, 0.7)`,
  cyanHover: `0 16px 50px -10px rgba(45, 167, 255, 0.85)`,
};

// Sitedeki `grid-lines`: 72px'lik ince ızgara dokusu.
export const GRID_LINES = {
  backgroundImage: `linear-gradient(to right, rgba(234,240,248,0.05) 1px, transparent 1px),
     linear-gradient(to bottom, rgba(234,240,248,0.05) 1px, transparent 1px)`,
  backgroundSize: "72px 72px",
};

export default BRAND;
